import React from 'react';
import { TimerIcon } from 'lucide-react';
export function Mechanism() {
  return <section className="w-full bg-teal-dark py-16 text-white lg:py-24" data-id="element-128" data-mp="1m9ecx6vnsf77">
      <div className="mx-auto max-w-5xl px-6" data-id="element-129" data-mp="1mbr3u9je9zwe">
        <div className="grid gap-10 lg:grid-cols-[auto_1fr] lg:gap-14" data-id="element-130" data-mp="1r8hkoz30wziv">
          <div className="flex items-center gap-4 lg:flex-col lg:items-start" data-id="element-131" data-mp="1w7lrxk6e0n6k">
            <TimerIcon className="h-14 w-14 flex-none text-teal-soft" aria-hidden="true" data-id="element-132" data-mp="1w5hqr9zvi29z" />
            <p className="font-serif text-6xl font-semibold leading-none text-white lg:text-7xl" data-id="element-133" data-mp="13in72favr6xk">
              3
              <span className="ml-2 font-sans text-xl font-medium uppercase tracking-wide text-teal-soft lg:block lg:ml-0 lg:mt-2" data-id="element-134" data-mp="18hzwn7t4ys3u">
                minutos
              </span>
            </p>
          </div>

          <div data-id="element-135" data-mp="fskfs1esi500">
            <h2 className="font-serif text-3xl font-semibold leading-tight sm:text-4xl lg:text-[2.75rem]" data-id="element-136" data-mp="ft2lrpr97xl4">
              Presentamos la Regla de los 3 Minutos
            </h2>
            <div className="mt-6 space-y-6 font-sans text-xl leading-relaxed text-teal-soft sm:text-[1.375rem]" data-id="element-137" data-mp="pbkfunxrr4z4">
              <p data-id="element-138" data-mp="keu58g4qh1l3">
                Es una técnica de descompresión linfática que se realiza{' '}
                <strong className="font-semibold text-white" data-id="element-139" data-mp="flhoes6apz2w">
                  antes de levantarse de la cama
                </strong>
                .
              </p>
              <p data-id="element-140" data-mp="6mnp2u1kyuln">
                En solo 180 segundos, este método actúa como una “bomba manual”
                que drena la toxicidad de sus nudillos, rodillas y cadera,
                lubricando el cartílago antes de que reciba el peso de su
                cuerpo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}